import { ConfigCheckName } from '@api/generated/graphql';

export const configReviewStrings = {
  pageTitle: 'Configuration Health',
  pageDescription:
    "Review every tenant's onboarding, setup, and configuration settings in one place. Select a tenant to view individual checks and follow links to fix anything flagged.",
  errorMessage: 'Failed to load configuration health. Please try again later.',

  summaryCards: {
    fullyConfigured: 'Fully configured',
    needsReview: 'Needs review',
    actionNeeded: 'Action needed',
  },

  tabs: {
    onboarding: 'Onboarding',
    setup: 'Setup',
    configurations: 'Configurations',
  },

  acknowledge: {
    button: 'Acknowledge as intentional',
    markForReview: 'Mark for review',
  },

  unknown: {
    label: 'Unknown',
    description: "We couldn't check this right now. Refresh to try again.",
  },

  generalBanner:
    'Your Contact Center Pro account has configuration issues that require attention. Unresolved issues may prevent calls, recording, or agent availability.',

  bannerText: {
    [ConfigCheckName.TenantsSyncedIntoCcp]:
      'There are no tenants synced into this Contact Center Pro instance. Please contact Onboarding or sign up for CCPro today.',
    [ConfigCheckName.FgCallRecordingEnhancementsEnabled]:
      'Your account is missing a required configuration (call recording). Please contact Support.',
    [ConfigCheckName.FgCallDataChangeNotificationsEnabled]:
      'Your account is missing a required configuration (call events). Please contact Support.',
    [ConfigCheckName.ExternalCallerIdSet]:
      'Default Account Outbound calling is not configured. Your agents cannot make outbound calls until an External Caller ID is set.',
    [ConfigCheckName.FgOutboundCallerIdSet]:
      'Outbound caller ID is not properly configured for one or more tenants. Agents may display incorrect numbers when calling customers.',
    [ConfigCheckName.NoUnassignedPhoneNumbers]:
      'You have phone number(s) not assigned to any workflow or user. Callers to these numbers will receive no answer.',
    [ConfigCheckName.NoWorkflowsWithDeadEnds]:
      'Workflow(s) have branches with no configured endpoint. Calls reaching these branches may be dropped.',
    [ConfigCheckName.StCoreAutomaticRecordingEnabled]:
      'Recording is not enabled in ServiceTitan for some tenants. Call records will not appear in Conversation History.',
    [ConfigCheckName.CcpRecordingSettingsSet]:
      'Call recording is not configured for some queues or agents. Calls may not be recorded as expected.',
    [ConfigCheckName.FgEmbeddedDialpadPhoneDisabled]:
      'Your account still has Phones Pro settings active. This may cause calls to route incorrectly or Dialpad to interfere with Contact Center Pro.',
    [ConfigCheckName.FgEnablePowerdialerDisabled]:
      'Your account still has Phones Pro settings active. This may cause calls to route incorrectly or Dialpad to interfere with Contact Center Pro.',
    [ConfigCheckName.FgPhonesProCallContinuityToggleDisabled]:
      'Your account still has Phones Pro settings active. This may cause calls to route incorrectly or Dialpad to interfere with Contact Center Pro.',
    [ConfigCheckName.FgServiceTitanPhonesUserDisabled]:
      'Your account still has Phones Pro settings active. This may cause calls to route incorrectly or Dialpad to interfere with Contact Center Pro.',
    [ConfigCheckName.FgSecondChanceLeadsDisabled]:
      'Your account still has Phones Pro settings active. This may cause calls to route incorrectly or Dialpad to interfere with Contact Center Pro.',
    [ConfigCheckName.FgSecondChanceLeadsModelVersionDisabled]:
      'Your account still has Phones Pro settings active. This may cause calls to route incorrectly or Dialpad to interfere with Contact Center Pro.',
    [ConfigCheckName.SimultaneousRingAgentCountNotHigh]:
      'Simultaneous ring with a very large number of agents can cause performance degradation and call delivery issues.',
  } as Record<string, string>,
} as const;
